// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#chip {\n  font-size: 15px !important;\n  margin-left: 5px\n}\n", ""]);
// Exports
module.exports = exports;
